import { Controller } from "@hotwired/stimulus"

// The file input is visually hidden inside the drop zone, so choosing a file
// leaves nothing on screen to confirm it. This swaps the zone for a line
// naming the chosen file, with a way back to an empty selection.
//
// Drag and drop is an enhancement here: the zone is a label wrapping a real
// input, so click and keyboard still work with this controller absent.
export default class extends Controller {
  static targets = ["input", "zone", "chosen", "name", "submit", "change"]
  static classes = ["dragging"]

  connect() {
    this.#render()
  }

  choose() {
    this.#render()
    if (this.inputTarget.files.length && this.hasChangeTarget) this.changeTarget.focus()
  }

  change() {
    this.inputTarget.click()
  }

  clear() {
    this.inputTarget.value = ""
    this.#render()
    this.inputTarget.focus()
  }

  dragover(event) {
    event.preventDefault()
    this.#setDragging(true)
  }

  dragleave(event) {
    event.preventDefault()
    this.#setDragging(false)
  }

  drop(event) {
    event.preventDefault()
    this.#setDragging(false)
    if (event.dataTransfer.files.length === 0) return

    this.inputTarget.files = event.dataTransfer.files
    this.choose()
  }

  // The file is not validated here. Type and size are enforced on the model,
  // which reports why in the form; a second set of rules in the browser would
  // be one more place for the two to disagree.
  #render() {
    const file = this.inputTarget.files[0]

    this.zoneTarget.classList.toggle("hidden", Boolean(file))
    this.chosenTarget.classList.toggle("hidden", !file)
    if (file) this.nameTarget.textContent = `${file.name} · ${new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 }).format(file.size / 1024)} KB`
    if (this.hasSubmitTarget) this.submitTarget.disabled = !file
  }

  #setDragging(dragging) {
    if (this.draggingClasses.length === 0) return

    this.draggingClasses.forEach((name) => {
      this.zoneTarget.classList.toggle(name, dragging)
    })
  }
}
